
/**
 * Ex: <util-dropdown list="$ctrl.col" ng-model="$ctrl.model.prop" ng-change="$ctrl.method()"></util-dropdown>
 *
 * When using this component, the assigned ng-model ($ctrl.model.prop) will automatically hook into
 * the selection binding, and an assigned ng-change ($ctrl.method) will be triggered when an option is clicked.
 */

import template from './UtilDropdown.html';

export default {
  name: 'utilDropdown',
  template,
  require: {
    ngModelCtrl: 'ngModel'
  },
  bindings: {
    editing: '<?',
    list: '<',
    selection: '=ngModel'
  },
  controller() {
    const vm = this;
    vm.$onChanges = (changes) => {
      if (_.has(changes, 'list.currentValue') && changes.list.currentValue !== changes.list.previousValue) {
        const list = changes.list.currentValue;
        vm.sortedList = (_.isArray(list) ? _.map(list, val => [val, val]) : _.entries(list))
          .sort((aa, bb) => aa[1].localeCompare(bb[1]));
      }
    };

    vm.changed = () => {
      vm.ngModelCtrl.$setViewValue(vm.selection, 'click');
    };

    vm.editingValue = () => {
      const displayValue = _.isArray(vm.list) ? vm.selection : vm.list[vm.selection];
      return displayValue;
    };
  }
};
